export enum Pages {
  CheckCode = 'CheckCode',
  Intro = 'Intro',
  Questions = 'Questions',
  ConfirmContactInfo = 'ConfirmContactInfo',
  ConfirmRelationship = 'ConfirmRelationship',
  Prospect = 'Prospect',
  ThankPage = 'ThankPage'
}

export enum IntroPages {
  WelcomeScreen = 'Welcome Screen',
  ContentWaiver = 'Consent Waiver',
  FirstDecline = 'First decline',
  SecondDecline = 'Second decline'
}
